import { render, staticRenderFns } from "./ListCart.vue?vue&type=template&id=6640d1f4&scoped=true&"
import script from "./ListCart.vue?vue&type=script&lang=ts&"
export * from "./ListCart.vue?vue&type=script&lang=ts&"
import style0 from "./ListCart.vue?vue&type=style&index=0&id=6640d1f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640d1f4",
  null
  
)

export default component.exports